module.exports = __webpack_public_path__ + "img/health-colored.7b24c04e.svg";